import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { calculatePositions } from 'utils/redux'
import sortedLayoutsSelector from '../selectors/sortedLayouts'
import {
  addLayout as addLayoutToView
} from '../redux/view'
import {
  add as addLayout,
  setPosition as setLayoutPosition
} from '../redux/layouts'

export default function * requestCopyLayout (action) {
  const { layoutId, name, position, onSuccess } = action.payload

  const tempId = `temp-${new Date().getTime()}`

  const state = yield select()

  const layouts = sortedLayoutsSelector(state)

  const positions = calculatePositions({
    array: layouts,
    position
  })

  let optimisticAction

  if (position !== undefined) {
    optimisticAction = yield optimisticPut([
      addLayout({
        id: tempId,
        name,
        position,
        isBusy: true
      }),
      addLayoutToView({
        id: tempId
      }),
      ...positions.map(({ id, position }) =>
        setLayoutPosition({
          id,
          position
        })
      )
    ])
  }

  try {
    const result = yield call(apiAction, 'CopyHomeLayout', {
      homeLayoutId: layoutId,
      name,
      position,
    })

    if (optimisticAction) {
      yield optimisticAction.revert()
    }

    onSuccess && onSuccess(result)
  } catch (e) {
    if (optimisticAction) {
      yield optimisticAction.revert()
    }
  }
}
